"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DocsValidation;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Documentation Code Validation Page
 *
 * This page contains all React examples from the documentation
 * for manual testing purposes.
 *
 * To use:
 * 1. Connect your wallet
 * 2. Test each section by clicking the buttons
 * 3. Check console for results
 * 4. Mark off in VALIDATION_CHECKLIST.md
 */
var react_1 = require("react");
var web3_js_1 = require("@solana/web3.js");
var spl_token_1 = require("@solana/spl-token");
var solana_headless_react_1 = require("@hermis/solana-headless-react");
var kit_1 = require("@solana/kit");
var kit_2 = require("@solana/kit");
var system_1 = require("@solana-program/system");
var compute_budget_1 = require("@solana-program/compute-budget");
var token_1 = require("@solana-program/token");
function DocsValidation() {
    var _this = this;
    var _a = (0, solana_headless_react_1.useWallet)(), publicKey = _a.publicKey, addressString = _a.addressString, transactionSigner = _a.transactionSigner, signAndSendTransaction = _a.signAndSendTransaction, signTransaction = _a.signTransaction, signAllTransactions = _a.signAllTransactions, connected = _a.connected;
    var dualConnection = (0, solana_headless_react_1.useConnection)().connection;
    var connection = dualConnection;
    var testRecipient = (0, react_1.useState)('9ksQrNQ5GEB4AKpuDrRxF8KASAtJ7zXXm81XSqsqNyhR')[0]; // Valid address for testing
    var testTokenMint = (0, react_1.useState)('Gh9ZwEmdLJ8DscKNTkTqPbNwLNNBjuSzaG9Vp2KGtKJr')[0]; // Devnet USDC
    var testTokenAmount = (0, react_1.useState)(1000000)[0]; // 1 USDC (6 decimals)
    var _b = (0, react_1.useState)([]), logs = _b[0], setLogs = _b[1];
    var addLog = function (message, type, errorDetails) {
        if (type === void 0) { type = 'info'; }
        var timestamp = new Date().toLocaleTimeString();
        var logMessage = "[".concat(timestamp, "] ").concat(type.toUpperCase(), ": ").concat(message);
        console.log(logMessage);
        // If error details provided, log the full error object to console for debugging
        if (errorDetails) {
            console.error('Full error details:', errorDetails);
            if (errorDetails.cause) {
                console.error('Error cause:', errorDetails.cause);
            }
            if (errorDetails.context) {
                console.error('Error context:', errorDetails.context);
            }
        }
        setLogs(function (prev) { return __spreadArray(__spreadArray([], prev, true), [logMessage], false); });
    };
    // Helper function to check if a token account exists
    var checkTokenAccount = function (tokenAddress) { return __awaiter(_this, void 0, Promise, function () {
        var accountInfo, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, connection.getAccountInfo(tokenAddress)];
                case 1:
                    accountInfo = _a.sent();
                    return [2 /*return*/, accountInfo !== null];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // ==========================================================================
    // 1. BASIC TRANSFER - React + web3.js
    // ==========================================================================
    var testBasicTransferWeb3 = function () { return __awaiter(_this, void 0, void 0, function () {
        var transaction, blockhash, signature, error_2, errorMsg, causeMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    addLog('Testing Basic Transfer (React + web3.js)...');
                    transaction = new web3_js_1.Transaction();
                    transaction.add(web3_js_1.SystemProgram.transfer({
                        fromPubkey: publicKey,
                        toPubkey: new web3_js_1.PublicKey(testRecipient),
                        lamports: 0.001 * web3_js_1.LAMPORTS_PER_SOL
                    }));
                    return [4 /*yield*/, connection.getLatestBlockhash()];
                case 1:
                    blockhash = (_a.sent()).blockhash;
                    transaction.recentBlockhash = blockhash;
                    transaction.feePayer = publicKey;
                    return [4 /*yield*/, signAndSendTransaction(transaction, connection)];
                case 2:
                    signature = _a.sent();
                    addLog("\u2705 Basic Transfer (web3.js) SUCCESS: ".concat(signature), 'success');
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    errorMsg = error_2.message || String(error_2);
                    causeMsg = error_2.cause ? " | Cause: ".concat(error_2.cause.message || String(error_2.cause)) : '';
                    addLog("\u274C Basic Transfer (web3.js) FAILED: ".concat(errorMsg).concat(causeMsg), 'error', error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // ==========================================================================
    // 1. BASIC TRANSFER - React + Kit (Proper Kit Pattern with pipe)
    // ==========================================================================
    var testBasicTransferKit = function () { return __awaiter(_this, void 0, void 0, function () {
        var rpc, latestBlockhash_1, message, signature, error_3, errorMsg, causeMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    addLog('Testing Basic Transfer (React + Kit)...');
                    rpc = (0, kit_2.createSolanaRpc)((0, kit_2.devnet)('https://api.devnet.solana.com'));
                    return [4 /*yield*/, rpc.getLatestBlockhash().send()];
                case 1:
                    latestBlockhash_1 = (_a.sent()).value;
                    message = (0, kit_1.pipe)((0, kit_1.createTransactionMessage)({ version: 0 }), function (m) { return (0, kit_1.setTransactionMessageFeePayerSigner)(transactionSigner, m); }, function (m) { return (0, kit_1.setTransactionMessageLifetimeUsingBlockhash)(latestBlockhash_1, m); }, function (m) { return (0, kit_1.appendTransactionMessageInstruction)((0, system_1.getTransferSolInstruction)({
                        source: transactionSigner,
                        destination: (0, kit_1.address)(testRecipient),
                        amount: (0, kit_1.lamports)(BigInt(0.001 * 1000000000))
                    }), m); });
                    return [4 /*yield*/, signAndSendTransaction(message, rpc)];
                case 2:
                    signature = _a.sent();
                    addLog("\u2705 Basic Transfer (Kit) SUCCESS: ".concat(signature), 'success');
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    errorMsg = error_3.message || String(error_3);
                    causeMsg = error_3.cause ? " | Cause: ".concat(error_3.cause.message || String(error_3.cause)) : '';
                    addLog("\u274C Basic Transfer (Kit) FAILED: ".concat(errorMsg).concat(causeMsg), 'error', error_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // ==========================================================================
    // 2. SIGN ONLY - React + web3.js
    // ==========================================================================
    var testSignOnlyWeb3 = function () { return __awaiter(_this, void 0, void 0, function () {
        var transaction, blockhash, signedTx, error_4, errorMsg, causeMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    addLog('Testing Sign Only (React + web3.js)...');
                    transaction = new web3_js_1.Transaction();
                    transaction.add(web3_js_1.SystemProgram.transfer({
                        fromPubkey: publicKey,
                        toPubkey: new web3_js_1.PublicKey(testRecipient),
                        lamports: 0.001 * web3_js_1.LAMPORTS_PER_SOL
                    }));
                    return [4 /*yield*/, connection.getLatestBlockhash()];
                case 1:
                    blockhash = (_a.sent()).blockhash;
                    transaction.recentBlockhash = blockhash;
                    transaction.feePayer = publicKey;
                    return [4 /*yield*/, signTransaction(transaction)];
                case 2:
                    signedTx = _a.sent();
                    addLog("\u2705 Sign Only (web3.js) SUCCESS: Transaction signed (".concat(signedTx.signatures.length, " signatures)"), 'success');
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _a.sent();
                    errorMsg = error_4.message || String(error_4);
                    causeMsg = error_4.cause ? " | Cause: ".concat(error_4.cause.message || String(error_4.cause)) : '';
                    addLog("\u274C Sign Only (web3.js) FAILED: ".concat(errorMsg).concat(causeMsg), 'error', error_4);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // ==========================================================================
    // 2. SIGN ONLY - React + Kit (Proper Kit Pattern with pipe)
    // ==========================================================================
    var testSignOnlyKit = function () { return __awaiter(_this, void 0, void 0, function () {
        var rpc, latestBlockhash_2, message, error_5, errorMsg, causeMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    addLog('Testing Sign Only (React + Kit)...');
                    rpc = (0, kit_2.createSolanaRpc)((0, kit_2.devnet)('https://api.devnet.solana.com'));
                    return [4 /*yield*/, rpc.getLatestBlockhash().send()];
                case 1:
                    latestBlockhash_2 = (_a.sent()).value;
                    message = (0, kit_1.pipe)((0, kit_1.createTransactionMessage)({ version: 0 }), function (m) { return (0, kit_1.setTransactionMessageFeePayerSigner)(transactionSigner, m); }, function (m) { return (0, kit_1.setTransactionMessageLifetimeUsingBlockhash)(latestBlockhash_2, m); }, function (m) { return (0, kit_1.appendTransactionMessageInstruction)((0, system_1.getTransferSolInstruction)({
                        source: transactionSigner,
                        destination: (0, kit_1.address)(testRecipient),
                        amount: (0, kit_1.lamports)(BigInt(0.001 * 1000000000))
                    }), m); });
                    return [4 /*yield*/, signTransaction(message)];
                case 2:
                    _a.sent();
                    addLog("\u2705 Sign Only (Kit) SUCCESS: Message signed", 'success');
                    return [3 /*break*/, 4];
                case 3:
                    error_5 = _a.sent();
                    errorMsg = error_5.message || String(error_5);
                    causeMsg = error_5.cause ? " | Cause: ".concat(error_5.cause.message || String(error_5.cause)) : '';
                    addLog("\u274C Sign Only (Kit) FAILED: ".concat(errorMsg).concat(causeMsg), 'error', error_5);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // ==========================================================================
    // 3. SIGN MULTIPLE - React + web3.js
    // ==========================================================================
    var testSignMultipleWeb3 = function () { return __awaiter(_this, void 0, void 0, function () {
        var transactions, i, transaction, blockhash, signedTxs, error_6, errorMsg, causeMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, , 7]);
                    addLog('Testing Sign Multiple (React + web3.js)...');
                    transactions = [];
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < 3)) return [3 /*break*/, 4];
                    transaction = new web3_js_1.Transaction();
                    transaction.add(web3_js_1.SystemProgram.transfer({
                        fromPubkey: publicKey,
                        toPubkey: new web3_js_1.PublicKey(testRecipient),
                        lamports: 0.001 * web3_js_1.LAMPORTS_PER_SOL
                    }));
                    return [4 /*yield*/, connection.getLatestBlockhash()];
                case 2:
                    blockhash = (_a.sent()).blockhash;
                    transaction.recentBlockhash = blockhash;
                    transaction.feePayer = publicKey;
                    transactions.push(transaction);
                    _a.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4: return [4 /*yield*/, signAllTransactions(transactions)];
                case 5:
                    signedTxs = _a.sent();
                    addLog("\u2705 Sign Multiple (web3.js) SUCCESS: ".concat(signedTxs.length, " transactions signed"), 'success');
                    return [3 /*break*/, 7];
                case 6:
                    error_6 = _a.sent();
                    errorMsg = error_6.message || String(error_6);
                    causeMsg = error_6.cause ? " | Cause: ".concat(error_6.cause.message || String(error_6.cause)) : '';
                    addLog("\u274C Sign Multiple (web3.js) FAILED: ".concat(errorMsg).concat(causeMsg), 'error', error_6);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    // ==========================================================================
    // 3. SIGN MULTIPLE - React + Kit (Proper Kit Pattern with pipe)
    // ==========================================================================
    var testSignMultipleKit = function () { return __awaiter(_this, void 0, void 0, function () {
        var rpc, latestBlockhash_3, messages, i, message, signedMessages, error_7, errorMsg, causeMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    addLog('Testing Sign Multiple (React + Kit)...');
                    rpc = (0, kit_2.createSolanaRpc)((0, kit_2.devnet)('https://api.devnet.solana.com'));
                    return [4 /*yield*/, rpc.getLatestBlockhash().send()];
                case 1:
                    latestBlockhash_3 = (_a.sent()).value;
                    messages = [];
                    for (i = 0; i < 3; i++) {
                        message = (0, kit_1.pipe)((0, kit_1.createTransactionMessage)({ version: 0 }), function (m) { return (0, kit_1.setTransactionMessageFeePayerSigner)(transactionSigner, m); }, function (m) { return (0, kit_1.setTransactionMessageLifetimeUsingBlockhash)(latestBlockhash_3, m); }, function (m) { return (0, kit_1.appendTransactionMessageInstruction)((0, system_1.getTransferSolInstruction)({
                            source: transactionSigner,
                            destination: (0, kit_1.address)(testRecipient),
                            amount: (0, kit_1.lamports)(BigInt(0.001 * 1000000000))
                        }), m); });
                        messages.push(message);
                    }
                    return [4 /*yield*/, signAllTransactions(messages)];
                case 2:
                    signedMessages = _a.sent();
                    addLog("\u2705 Sign Multiple (Kit) SUCCESS: ".concat(signedMessages.length, " messages signed"), 'success');
                    return [3 /*break*/, 4];
                case 3:
                    error_7 = _a.sent();
                    errorMsg = error_7.message || String(error_7);
                    causeMsg = error_7.cause ? " | Cause: ".concat(error_7.cause.message || String(error_7.cause)) : '';
                    addLog("\u274C Sign Multiple (Kit) FAILED: ".concat(errorMsg).concat(causeMsg), 'error', error_7);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // ==========================================================================
    // 4. WITH CONFIRMATION - React + web3.js
    // ==========================================================================
    var testWithConfirmationWeb3 = function () { return __awaiter(_this, void 0, void 0, function () {
        var transaction, blockhash, signature, error_8, errorMsg, causeMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    addLog('Testing With Confirmation (React + web3.js)...');
                    transaction = new web3_js_1.Transaction();
                    transaction.add(web3_js_1.SystemProgram.transfer({
                        fromPubkey: publicKey,
                        toPubkey: new web3_js_1.PublicKey(testRecipient),
                        lamports: 0.001 * web3_js_1.LAMPORTS_PER_SOL
                    }));
                    return [4 /*yield*/, connection.getLatestBlockhash()];
                case 1:
                    blockhash = (_a.sent()).blockhash;
                    transaction.recentBlockhash = blockhash;
                    transaction.feePayer = publicKey;
                    return [4 /*yield*/, signAndSendTransaction(transaction, connection)];
                case 2:
                    signature = _a.sent();
                    addLog('Waiting for confirmation...');
                    return [4 /*yield*/, connection.confirmTransaction(signature, 'confirmed')];
                case 3:
                    _a.sent();
                    addLog("\u2705 With Confirmation (web3.js) SUCCESS: ".concat(signature, " (confirmed)"), 'success');
                    return [3 /*break*/, 5];
                case 4:
                    error_8 = _a.sent();
                    errorMsg = error_8.message || String(error_8);
                    causeMsg = error_8.cause ? " | Cause: ".concat(error_8.cause.message || String(error_8.cause)) : '';
                    addLog("\u274C With Confirmation (web3.js) FAILED: ".concat(errorMsg).concat(causeMsg), 'error', error_8);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // ==========================================================================
    // 4. WITH CONFIRMATION - React + Kit (Proper Kit Pattern with pipe)
    // ==========================================================================
    var testWithConfirmationKit = function () { return __awaiter(_this, void 0, void 0, function () {
        var rpc, latestBlockhash_4, message, signature, confirmed, i, value, error_9, errorMsg, causeMsg;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 8, , 9]);
                    addLog('Testing With Confirmation (React + Kit)...');
                    rpc = (0, kit_2.createSolanaRpc)((0, kit_2.devnet)('https://api.devnet.solana.com'));
                    return [4 /*yield*/, rpc.getLatestBlockhash().send()];
                case 1:
                    latestBlockhash_4 = (_b.sent()).value;
                    message = (0, kit_1.pipe)((0, kit_1.createTransactionMessage)({ version: 0 }), function (m) { return (0, kit_1.setTransactionMessageFeePayerSigner)(transactionSigner, m); }, function (m) { return (0, kit_1.setTransactionMessageLifetimeUsingBlockhash)(latestBlockhash_4, m); }, function (m) { return (0, kit_1.appendTransactionMessageInstruction)((0, system_1.getTransferSolInstruction)({
                        source: transactionSigner,
                        destination: (0, kit_1.address)(testRecipient),
                        amount: (0, kit_1.lamports)(BigInt(0.001 * 1000000000))
                    }), m); });
                    return [4 /*yield*/, signAndSendTransaction(message, rpc)];
                case 2:
                    signature = _b.sent();
                    addLog('Waiting for confirmation...');
                    confirmed = false;
                    i = 0;
                    _b.label = 3;
                case 3:
                    if (!(i < 30)) return [3 /*break*/, 7];
                    return [4 /*yield*/, rpc.getSignatureStatuses([signature]).send()];
                case 4:
                    value = (_b.sent()).value;
                    if (value && value[0] && value[0].confirmationStatus === 'confirmed' || ((_a = value[0]) === null || _a === void 0 ? void 0 : _a.confirmationStatus) === 'finalized') {
                        confirmed = true;
                        return [3 /*break*/, 7];
                    }
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 1000); })];
                case 5:
                    _b.sent();
                    _b.label = 6;
                case 6:
                    i++;
                    return [3 /*break*/, 3];
                case 7:
                    if (confirmed) {
                        addLog("\u2705 With Confirmation (Kit) SUCCESS: ".concat(signature, " (confirmed)"), 'success');
                    }
                    else {
                        addLog("\u26A0\uFE0F With Confirmation (Kit) TIMEOUT: ".concat(signature, " (not confirmed within 30s)"), 'error');
                    }
                    return [3 /*break*/, 9];
                case 8:
                    error_9 = _b.sent();
                    errorMsg = error_9.message || String(error_9);
                    causeMsg = error_9.cause ? " | Cause: ".concat(error_9.cause.message || String(error_9.cause)) : '';
                    addLog("\u274C With Confirmation (Kit) FAILED: ".concat(errorMsg).concat(causeMsg), 'error', error_9);
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    // ==========================================================================
    // 6. PRIORITY FEES - React + web3.js
    // ==========================================================================
    var testPriorityFeesWeb3 = function () { return __awaiter(_this, void 0, void 0, function () {
        var transaction, blockhash, signature, error_10, errorMsg, causeMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    addLog('Testing Priority Fees (React + web3.js)...');
                    transaction = new web3_js_1.Transaction();
                    // Add priority fee instruction
                    transaction.add(web3_js_1.ComputeBudgetProgram.setComputeUnitPrice({
                        microLamports: 1000,
                    }));
                    // Add actual transaction
                    transaction.add(web3_js_1.SystemProgram.transfer({
                        fromPubkey: publicKey,
                        toPubkey: new web3_js_1.PublicKey(testRecipient),
                        lamports: 0.001 * web3_js_1.LAMPORTS_PER_SOL
                    }));
                    return [4 /*yield*/, connection.getLatestBlockhash()];
                case 1:
                    blockhash = (_a.sent()).blockhash;
                    transaction.recentBlockhash = blockhash;
                    transaction.feePayer = publicKey;
                    return [4 /*yield*/, signAndSendTransaction(transaction, connection)];
                case 2:
                    signature = _a.sent();
                    addLog("\u2705 Priority Fees (web3.js) SUCCESS: ".concat(signature), 'success');
                    return [3 /*break*/, 4];
                case 3:
                    error_10 = _a.sent();
                    errorMsg = error_10.message || String(error_10);
                    causeMsg = error_10.cause ? " | Cause: ".concat(error_10.cause.message || String(error_10.cause)) : '';
                    addLog("\u274C Priority Fees (web3.js) FAILED: ".concat(errorMsg).concat(causeMsg), 'error', error_10);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // ==========================================================================
    // 6. PRIORITY FEES - React + Kit (Proper Kit Pattern with pipe)
    // ==========================================================================
    var testPriorityFeesKit = function () { return __awaiter(_this, void 0, void 0, function () {
        var rpc, latestBlockhash_5, priorityFeeInstruction_1, transferInstruction_1, message, signature, error_11, errorMsg, causeMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    addLog('Testing Priority Fees (React + Kit)...');
                    rpc = (0, kit_2.createSolanaRpc)((0, kit_2.devnet)('https://api.devnet.solana.com'));
                    return [4 /*yield*/, rpc.getLatestBlockhash().send()];
                case 1:
                    latestBlockhash_5 = (_a.sent()).value;
                    priorityFeeInstruction_1 = (0, compute_budget_1.getSetComputeUnitPriceInstruction)({
                        microLamports: 1000n
                    });
                    transferInstruction_1 = (0, system_1.getTransferSolInstruction)({
                        source: transactionSigner,
                        destination: (0, kit_1.address)(testRecipient),
                        amount: (0, kit_1.lamports)(BigInt(0.001 * 1000000000))
                    });
                    message = (0, kit_1.pipe)((0, kit_1.createTransactionMessage)({ version: 0 }), function (m) { return (0, kit_1.setTransactionMessageFeePayerSigner)(transactionSigner, m); }, function (m) { return (0, kit_1.setTransactionMessageLifetimeUsingBlockhash)(latestBlockhash_5, m); }, function (m) { return (0, kit_1.appendTransactionMessageInstructions)([priorityFeeInstruction_1, transferInstruction_1], m); });
                    return [4 /*yield*/, signAndSendTransaction(message, rpc)];
                case 2:
                    signature = _a.sent();
                    addLog("\u2705 Priority Fees (Kit) SUCCESS: ".concat(signature), 'success');
                    return [3 /*break*/, 4];
                case 3:
                    error_11 = _a.sent();
                    errorMsg = error_11.message || String(error_11);
                    causeMsg = error_11.cause ? " | Cause: ".concat(error_11.cause.message || String(error_11.cause)) : '';
                    addLog("\u274C Priority Fees (Kit) FAILED: ".concat(errorMsg).concat(causeMsg), 'error', error_11);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // ==========================================================================
    // 7. SPL TOKEN TRANSFER - React + web3.js
    // ==========================================================================
    var testTokenTransferWeb3 = function () { return __awaiter(_this, void 0, void 0, function () {
        var mintAddress, recipientAddress, fromTokenAccount, toTokenAccount, fromExists, toExists, transaction, blockhash, signature, error_12, errorMsg, causeMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 7, , 8]);
                    addLog('Testing SPL Token Transfer (React + web3.js)...');
                    mintAddress = new web3_js_1.PublicKey(testTokenMint);
                    recipientAddress = new web3_js_1.PublicKey(testRecipient);
                    return [4 /*yield*/, (0, spl_token_1.getAssociatedTokenAddress)(mintAddress, publicKey)];
                case 1:
                    fromTokenAccount = _a.sent();
                    return [4 /*yield*/, (0, spl_token_1.getAssociatedTokenAddress)(mintAddress, recipientAddress)];
                case 2:
                    toTokenAccount = _a.sent();
                    addLog('Checking token accounts...');
                    return [4 /*yield*/, checkTokenAccount(fromTokenAccount)];
                case 3:
                    fromExists = _a.sent();
                    return [4 /*yield*/, checkTokenAccount(toTokenAccount)];
                case 4:
                    toExists = _a.sent();
                    if (!fromExists) {
                        throw new Error("You don't have a token account for this token. ATA: ".concat(fromTokenAccount.toBase58()));
                    }
                    transaction = new web3_js_1.Transaction();
                    // If recipient's ATA doesn't exist, create it first
                    if (!toExists) {
                        addLog('Recipient ATA does not exist. Creating it...');
                        transaction.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(publicKey, // payer
                        toTokenAccount, // ata
                        recipientAddress, // owner
                        mintAddress // mint
                        ));
                    }
                    else {
                        addLog('Token accounts verified.');
                    }
                    addLog('Adding transfer instruction...');
                    // Add transfer instruction
                    transaction.add((0, spl_token_1.createTransferInstruction)(fromTokenAccount, toTokenAccount, publicKey, testTokenAmount));
                    return [4 /*yield*/, connection.getLatestBlockhash()];
                case 5:
                    blockhash = (_a.sent()).blockhash;
                    transaction.recentBlockhash = blockhash;
                    transaction.feePayer = publicKey;
                    return [4 /*yield*/, signAndSendTransaction(transaction, connection)];
                case 6:
                    signature = _a.sent();
                    addLog("\u2705 SPL Token Transfer (web3.js) SUCCESS: ".concat(signature), 'success');
                    return [3 /*break*/, 8];
                case 7:
                    error_12 = _a.sent();
                    errorMsg = error_12.message || String(error_12);
                    causeMsg = error_12.cause ? " | Cause: ".concat(error_12.cause.message || String(error_12.cause)) : '';
                    addLog("\u274C SPL Token Transfer (web3.js) FAILED: ".concat(errorMsg).concat(causeMsg), 'error', error_12);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    // ==========================================================================
    // 7. SPL TOKEN TRANSFER - React + Kit (Proper Kit Pattern with pipe)
    // ==========================================================================
    var testTokenTransferKit = function () { return __awaiter(_this, void 0, void 0, function () {
        var rpc, mintAddress, recipientAddress, fromTokenAccount, toTokenAccount, fromExists, toExists, instructions_1, latestBlockhash_6, message, signature, error_13, errorMsg, causeMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 7, , 8]);
                    addLog('Testing SPL Token Transfer (React + Kit)...');
                    rpc = (0, kit_2.createSolanaRpc)((0, kit_2.devnet)('https://api.devnet.solana.com'));
                    mintAddress = new web3_js_1.PublicKey(testTokenMint);
                    recipientAddress = new web3_js_1.PublicKey(testRecipient);
                    return [4 /*yield*/, (0, spl_token_1.getAssociatedTokenAddress)(mintAddress, publicKey)];
                case 1:
                    fromTokenAccount = _a.sent();
                    return [4 /*yield*/, (0, spl_token_1.getAssociatedTokenAddress)(mintAddress, recipientAddress)];
                case 2:
                    toTokenAccount = _a.sent();
                    addLog('Checking token accounts...');
                    return [4 /*yield*/, checkTokenAccount(fromTokenAccount)];
                case 3:
                    fromExists = _a.sent();
                    return [4 /*yield*/, checkTokenAccount(toTokenAccount)];
                case 4:
                    toExists = _a.sent();
                    if (!fromExists) {
                        throw new Error("You don't have a token account for this token. ATA: ".concat(fromTokenAccount.toBase58()));
                    }
                    instructions_1 = [];
                    // If recipient's ATA doesn't exist, create it first
                    if (!toExists) {
                        addLog('Recipient ATA does not exist. Creating it...');
                        instructions_1.push((0, token_1.getCreateAssociatedTokenIdempotentInstruction)({
                            payer: transactionSigner,
                            ata: (0, kit_1.address)(toTokenAccount.toBase58()),
                            owner: (0, kit_1.address)(recipientAddress.toBase58()),
                            mint: (0, kit_1.address)(mintAddress.toBase58())
                        }));
                    }
                    else {
                        addLog('Token accounts verified.');
                    }
                    addLog('Adding transfer instruction...');
                    // Add transfer instruction
                    instructions_1.push((0, token_1.getTransferInstruction)({
                        source: (0, kit_1.address)(fromTokenAccount.toBase58()),
                        destination: (0, kit_1.address)(toTokenAccount.toBase58()),
                        authority: transactionSigner,
                        amount: BigInt(testTokenAmount)
                    }));
                    return [4 /*yield*/, rpc.getLatestBlockhash().send()];
                case 5:
                    latestBlockhash_6 = (_a.sent()).value;
                    message = (0, kit_1.pipe)((0, kit_1.createTransactionMessage)({ version: 0 }), function (m) { return (0, kit_1.setTransactionMessageFeePayerSigner)(transactionSigner, m); }, function (m) { return (0, kit_1.setTransactionMessageLifetimeUsingBlockhash)(latestBlockhash_6, m); }, function (m) { return (0, kit_1.appendTransactionMessageInstructions)(instructions_1, m); });
                    return [4 /*yield*/, signAndSendTransaction(message, rpc)];
                case 6:
                    signature = _a.sent();
                    addLog("\u2705 SPL Token Transfer (Kit) SUCCESS: ".concat(signature), 'success');
                    return [3 /*break*/, 8];
                case 7:
                    error_13 = _a.sent();
                    errorMsg = error_13.message || String(error_13);
                    causeMsg = error_13.cause ? " | Cause: ".concat(error_13.cause.message || String(error_13.cause)) : '';
                    addLog("\u274C SPL Token Transfer (Kit) FAILED: ".concat(errorMsg).concat(causeMsg), 'error', error_13);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    // ==========================================================================
    // 7. TEST createKitTransaction HELPER
    // ==========================================================================
    var testCreateKitTransactionHelper = function () { return __awaiter(_this, void 0, void 0, function () {
        var rpc, transferInstruction, transactionMessage, signature, error_14, errorMsg, causeMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    addLog('Testing createKitTransaction helper...');
                    rpc = (0, kit_2.createSolanaRpc)((0, kit_2.devnet)('https://api.devnet.solana.com'));
                    transferInstruction = (0, system_1.getTransferSolInstruction)({
                        source: transactionSigner,
                        destination: (0, kit_1.address)(testRecipient),
                        amount: (0, kit_1.lamports)(BigInt(0.001 * 1000000000))
                    });
                    return [4 /*yield*/, (0, solana_headless_react_1.createKitTransaction)(rpc, (0, kit_1.address)(addressString), [transferInstruction])];
                case 1:
                    transactionMessage = _a.sent();
                    addLog('Transaction created successfully with createKitTransaction helper', 'success');
                    return [4 /*yield*/, signAndSendTransaction(transactionMessage, rpc)];
                case 2:
                    signature = _a.sent();
                    addLog("createKitTransaction Helper SUCCESS: ".concat(signature), 'success');
                    return [3 /*break*/, 4];
                case 3:
                    error_14 = _a.sent();
                    errorMsg = error_14.message || String(error_14);
                    causeMsg = error_14.cause ? " | Cause: ".concat(error_14.cause.message || String(error_14.cause)) : '';
                    addLog("\u274C createKitTransaction Helper FAILED: ".concat(errorMsg).concat(causeMsg), 'error', error_14);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // ==========================================================================
    // RENDER
    // ==========================================================================
    if (!connected) {
        return ((0, jsx_runtime_1.jsxs)("div", { style: { padding: '20px', fontFamily: 'monospace' }, children: [(0, jsx_runtime_1.jsx)("h1", { children: "\uD83D\uDCCB Documentation Validation" }), (0, jsx_runtime_1.jsx)("p", { style: { color: 'orange' }, children: "\u26A0\uFE0F Please connect your wallet first to test examples" })] }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { style: { padding: '20px', fontFamily: 'monospace', maxWidth: '1200px' }, children: [(0, jsx_runtime_1.jsx)("h1", { children: "\uD83D\uDCCB Documentation Code Validation" }), (0, jsx_runtime_1.jsx)("p", { children: "Testing all React examples from docs/core-concepts/transactions.mdx" }), (0, jsx_runtime_1.jsxs)("div", { style: { background: '#1a1a1a', padding: '10px', marginBottom: '20px', borderRadius: '4px' }, children: [(0, jsx_runtime_1.jsx)("strong", { children: "Connected:" }), " ", addressString || (publicKey === null || publicKey === void 0 ? void 0 : publicKey.toBase58().slice(0, 8)), "..."] }), (0, jsx_runtime_1.jsxs)("section", { style: { marginBottom: '30px', borderLeft: '3px solid #9945FF', paddingLeft: '15px' }, children: [(0, jsx_runtime_1.jsx)("h2", { children: "1\uFE0F\u20E3 Basic Transfer" }), (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', gap: '10px', flexWrap: 'wrap' }, children: [(0, jsx_runtime_1.jsx)("button", { onClick: testBasicTransferWeb3, style: buttonStyle, children: "Test React + web3.js" }), (0, jsx_runtime_1.jsx)("button", { onClick: testBasicTransferKit, style: buttonStyle, children: "Test React + Kit" })] })] }), (0, jsx_runtime_1.jsxs)("section", { style: { marginBottom: '30px', borderLeft: '3px solid #14F195', paddingLeft: '15px' }, children: [(0, jsx_runtime_1.jsx)("h2", { children: "2\uFE0F\u20E3 Sign Only" }), (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', gap: '10px', flexWrap: 'wrap' }, children: [(0, jsx_runtime_1.jsx)("button", { onClick: testSignOnlyWeb3, style: buttonStyle, children: "Test React + web3.js" }), (0, jsx_runtime_1.jsx)("button", { onClick: testSignOnlyKit, style: buttonStyle, children: "Test React + Kit" })] })] }), (0, jsx_runtime_1.jsxs)("section", { style: { marginBottom: '30px', borderLeft: '3px solid #9945FF', paddingLeft: '15px' }, children: [(0, jsx_runtime_1.jsx)("h2", { children: "3\uFE0F\u20E3 Sign Multiple" }), (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', gap: '10px', flexWrap: 'wrap' }, children: [(0, jsx_runtime_1.jsx)("button", { onClick: testSignMultipleWeb3, style: buttonStyle, children: "Test React + web3.js" }), (0, jsx_runtime_1.jsx)("button", { onClick: testSignMultipleKit, style: buttonStyle, children: "Test React + Kit" })] })] }), (0, jsx_runtime_1.jsxs)("section", { style: { marginBottom: '30px', borderLeft: '3px solid #14F195', paddingLeft: '15px' }, children: [(0, jsx_runtime_1.jsx)("h2", { children: "4\uFE0F\u20E3 With Confirmation" }), (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', gap: '10px', flexWrap: 'wrap' }, children: [(0, jsx_runtime_1.jsx)("button", { onClick: testWithConfirmationWeb3, style: buttonStyle, children: "Test React + web3.js" }), (0, jsx_runtime_1.jsx)("button", { onClick: testWithConfirmationKit, style: buttonStyle, children: "Test React + Kit" })] })] }), (0, jsx_runtime_1.jsxs)("section", { style: { marginBottom: '30px', borderLeft: '3px solid #9945FF', paddingLeft: '15px' }, children: [(0, jsx_runtime_1.jsx)("h2", { children: "5\uFE0F\u20E3 Priority Fees" }), (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', gap: '10px', flexWrap: 'wrap' }, children: [(0, jsx_runtime_1.jsx)("button", { onClick: testPriorityFeesWeb3, style: buttonStyle, children: "Test React + web3.js" }), (0, jsx_runtime_1.jsx)("button", { onClick: testPriorityFeesKit, style: buttonStyle, children: "Test React + Kit" })] })] }), (0, jsx_runtime_1.jsxs)("section", { style: { marginBottom: '30px', borderLeft: '3px solid #14F195', paddingLeft: '15px' }, children: [(0, jsx_runtime_1.jsx)("h2", { children: "6\uFE0F\u20E3 SPL Token Transfer" }), (0, jsx_runtime_1.jsx)("p", { style: { fontSize: '14px', color: '#888', margin: '5px 0' }, children: "Token: Devnet USDC (Gh9ZwE...) | Amount: 1 USDC (1,000,000 with 6 decimals)" }), (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', gap: '10px', flexWrap: 'wrap' }, children: [(0, jsx_runtime_1.jsx)("button", { onClick: testTokenTransferWeb3, style: buttonStyle, children: "Test React + web3.js" }), (0, jsx_runtime_1.jsx)("button", { onClick: testTokenTransferKit, style: buttonStyle, children: "Test React + Kit" })] })] }), (0, jsx_runtime_1.jsxs)("section", { style: { marginBottom: '30px', borderLeft: '3px solid #9945FF', paddingLeft: '15px' }, children: [(0, jsx_runtime_1.jsx)("h2", { children: "7\uFE0F\u20E3 createKitTransaction Helper" }), (0, jsx_runtime_1.jsx)("p", { style: { fontSize: '14px', color: '#888', margin: '5px 0' }, children: "Test the createKitTransaction helper utility with a real SOL transfer" }), (0, jsx_runtime_1.jsx)("div", { style: { display: 'flex', gap: '10px', flexWrap: 'wrap' }, children: (0, jsx_runtime_1.jsx)("button", { onClick: testCreateKitTransactionHelper, style: buttonStyle, children: "Test Helper" }) })] }), (0, jsx_runtime_1.jsxs)("section", { style: { marginTop: '40px' }, children: [(0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)("h2", { children: "\uD83D\uDCDD Test Logs" }), (0, jsx_runtime_1.jsx)("button", { onClick: function () { return setLogs([]); }, style: __assign(__assign({}, buttonStyle), { background: '#ff4444' }), children: "Clear Logs" })] }), (0, jsx_runtime_1.jsx)("div", { style: {
                            background: '#000',
                            color: '#0f0',
                            padding: '15px',
                            borderRadius: '4px',
                            maxHeight: '400px',
                            overflow: 'auto',
                            fontFamily: 'Courier New, monospace',
                            fontSize: '12px'
                        }, children: logs.length === 0 ? ((0, jsx_runtime_1.jsx)("p", { style: { color: '#666' }, children: "No logs yet. Click buttons above to test examples." })) : (logs.map(function (log, i) { return ((0, jsx_runtime_1.jsx)("div", { style: {
                                marginBottom: '5px',
                                color: log.includes('SUCCESS') ? '#0f0' : log.includes('FAILED') ? '#f00' : '#fff'
                            }, children: log }, i)); })) })] }), (0, jsx_runtime_1.jsxs)("section", { style: { marginTop: '30px', background: '#2a2a2a', padding: '15px', borderRadius: '4px' }, children: [(0, jsx_runtime_1.jsx)("h3", { children: "\u2139\uFE0F Instructions" }), (0, jsx_runtime_1.jsxs)("ol", { children: [(0, jsx_runtime_1.jsx)("li", { children: "Make sure you're on Devnet" }), (0, jsx_runtime_1.jsx)("li", { children: "Have some test SOL (use faucet if needed)" }), (0, jsx_runtime_1.jsx)("li", { children: "Click each test button" }), (0, jsx_runtime_1.jsx)("li", { children: "Check console and logs below for results" }), (0, jsx_runtime_1.jsxs)("li", { children: ["Mark off in ", (0, jsx_runtime_1.jsx)("code", { children: "docs/VALIDATION_CHECKLIST.md" })] })] }), (0, jsx_runtime_1.jsx)("p", { style: { color: '#888', fontSize: '12px', marginTop: '10px' }, children: "Note: Some tests use the burn address (11111...) so tokens are safely discarded" })] })] }));
}
var buttonStyle = {
    padding: '10px 20px',
    background: '#9945FF',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '14px',
    transition: 'all 0.2s',
};
